import React from "react";
import { Label } from "@/components/atoms/texts/label";
import getCurrencySymbolFromCode from "@/utils/getCurrencySymbolFromCode";
import { useTranslation } from "react-i18next";

export default function Cooptation({ data, dataOwner = false, verticalView = false, hideControls = false }) {
    const symbol = getCurrencySymbolFromCode(data?.currency);
    const [t] = useTranslation("global");

    return (
        <div className={`bg-white w-full shadow-md px-paddingLeftAndRight py-paddingTopAndBottom rounded-sm justify-start inline-flex gap-secondDegree ${verticalView ? "flex-col items-start" : "items-center"}`}>
            <div className="flex flex-col gap-firstDegree">
                {/* <Label fontWeight="bold">Cooptation</Label> */}
                <Label>
                    {dataOwner ? (
                        <>
                            <span className="font-semibold">{data?.cooptant?.firstname} {data?.cooptant?.lastname}</span>{' '}
                            <span>{t("consultants.statement.cooptation.cooptantReceivedRetribution")}</span>{' '}
                            <span className="font-semibold">{data?.coopted?.firstname} {data?.coopted?.lastname}</span>{' '}
                            <span>{t("consultants.statement.cooptation.heldAt", { cooptationPercentage: data?.cooptationPercentage })}</span>{' '}
                        </>
                    ) : (
                        <>
                            <span>{t("consultants.statement.cooptation.youReceivedRetribution")}</span>{' '}
                            <span className="font-semibold">{data?.coopted?.firstname} {data?.coopted?.lastname}</span>{' '}
                            <span>{t("consultants.statement.cooptation.heldAt")} {data?.cooptationPercentage}%.</span>{' '}
                        </>
                    )}
                    {data?.cooptationType === "COMMISSION_DISCOUNT" && t("consultants.statement.cooptation.detailsCommissionDiscount", { retributionPercentage: data?.retributionPercentage })}
                    {data?.cooptationType === "PERCENTAGE_RETRIBUTION" && t("consultants.statement.cooptation.detailsPercentageRetribution", { retributionPercentage: data?.retributionPercentage })}
                </Label>
            </div>
            {!verticalView && <div className="grow" ></div>}
            <div className={`flex flex-row gap-firstDegree min-w-[100px] ${verticalView ? "w-full" : ""}`}>
                <Label fontWeight="bold" message="consultants.statement.cooptation.amount" />
                <Label>{data?.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} {symbol}</Label>
            </div>
            <div className={`flex flex-row gap-firstDegree min-w-[100px] ${verticalView ? "w-full" : ""}`}>
                <Label fontWeight="bold" message="consultants.statement.cooptation.period" />
                <Label>{data?.month}/{data?.year}</Label>

            </div>

        </div>
    );
}
